import Page from "../../../services/page-data-feed";
import {route} from "preact-router";

/**
 * Il mobile originariamente era un unico componente da dare in iframe. 
 * Usava MobilePage per emulare il meccanismo del router.
 * Creo una classe compatibile che usi la URL per semplificare il routing
 */

class MobilePage {
	static history = [{name: 'home', data: {view: 'home', sport: '/sport/1'}}];

	static isTicketOpen() {
		return !!Page.data['mobile-ticket-open']
	}
	static toggleTicket() {
		Page.data['mobile-ticket-open'] = !Page.data['mobile-ticket-open'];
	}
	static closeTicket() {
		Page.data['mobile-ticket-open'] = false;
	}
	static openTicket() {
		Page.data['mobile-ticket-open'] = true;
	}

	static getCurrentPage() {
		return this.history[this.history.length - 1];
	}
	static setPage(page) {
		return this.history.push(page);
	}
	static goBack() {
		return this.history.splice(-1, 1);
	}
}

export default class URLBasedMobilePage {
	static init() {
		const href = window.location.href;
		if (window.location.hash) {
			window.history.replaceState(this.readPath(), "", window.location.pathname);
			window.history.pushState(this.readPath(), "", href);
		} else {
			window.history.replaceState(this.readPath(), "", href);
		}
	}
	
	static readPath() {
		const path = window.location.pathname;
		const hash = window.location.hash.substr(1);
		const pathTokens = path.split('/').slice(1);
		const entity = '/'+pathTokens.slice(2).join('/');
		
		return {
			name: pathTokens[0] || 'home',
			data: {
				view: pathTokens[1] || 'home',
				sport: entity.indexOf('/sport/') == 0 ? entity : void 0,
				tournament: entity.indexOf('/tournament/') == 0 ? entity : void 0,
				event: entity.indexOf('/event/') == 0 ? entity : void 0,
			}
		}
	}
	
	static writePath(page) {
		return !page.name ? '' 
			: !page.data || !page.data.view ? `/${page.name}`
			: !page.data.sport && !page.data.event && !page.data.tournament ? `/${page.name}/${page.data.view}`
			: `/${page.name}/${page.data.view}${page.data.sport || page.data.event || page.data.tournament}`
	}

	static getCurrentPage() {
		return window.history.state || this.readPath();
	}
	static setPage(page) {
		route(this.writePath(page));
		return window.history.replaceState(page, null);
	}
	static goBack() {
		return window.history.back();
	}
	static closeHashPopup() {
		window.location.hash = '';
		Page.rerender();
	}

	static isTicketOpen() {
		return !!Page.data['mobile-ticket-open']
	}
	static toggleTicket() {
		Page.data['mobile-ticket-open'] = !Page.data['mobile-ticket-open'];
	}
	static closeTicket() {
		Page.data['mobile-ticket-open'] = false;
	}
	static openTicket() {
		Page.data['mobile-ticket-open'] = true;
	}
	
	static listeners = {
		'right-menu': [],
		'left-menu': [],
	}

	static isRightMenuOpen() {
		return !!this.rightMenuOpen;
	}
	static openRightMenu() {
		this.rightMenuOpen = true;
		this.listeners['right-menu'].forEach(cb => cb());
	}
	static closeRightMenu() {
		this.rightMenuOpen = false;
		this.listeners['right-menu'].forEach(cb => cb());
	}
	static addOnRightMenuChange(cb) {
		this.listeners['right-menu'].push(cb);
	}
	static removeOnRightMenuChange(cb) {
		this.listeners['right-menu'] = this.listeners['right-menu'].filter(listener => listener != cb);
	}

	static isLeftMenuOpen() {
		return !!this.leftMenuOpen;
	}
	static openLeftMenu() {
		this.leftMenuOpen = true;
		this.listeners['left-menu'].forEach(cb => cb());
	}
	static closeLeftMenu() {
		this.leftMenuOpen = false;
		this.listeners['left-menu'].forEach(cb => cb());
	}
	static addOnLeftMenuChange(cb) {
		this.listeners['left-menu'].push(cb);
	}
	static removeOnLeftMenuChange(cb) {
		this.listeners['left-menu'] = this.listeners['left-menu'].filter(listener => listener != cb);
	}
}

URLBasedMobilePage.init();